const Drop = require('tether-drop');

require('../../sass/components/_tooltipThemePrimary.scss');
export const Droppler = {
    name: 'Droppler',
    props: [
        'position',
        'openOn',
        'classes',
        'constrainToWindow',
        'constrainToScrollParent',
        'hoverOpenDelay',
        'hoverCloseDelay',
        'focusDelay',
        'blurDelay',
        'tetherOptions',
        'remove'
    ],
    data() {
        return {
            drop: null
        }
    },
    methods: {
        open() {
            this.drop.open();
        },
        close() {
            this.drop.close()
        }
    },
    mounted() {
        this.drop = new Drop({
            target: this.$refs.dropTrigger,
            content: this.$refs.dropContent,
            position: this.position ? this.position : 'bottom left',
            openOn: this.openOn ? this.openOn : 'click',
            classes: this.classes ? this.classes : 'drop-theme-basic',
            constrainToWindow: this.constrainToWindow ? true : false,
            constrainToScrollParent: this.constrainToScrollParent ? true : false,
            hoverOpenDelay: this.hoverOpenDelay ? this.hoverOpenDelay : 0,
            hoverCloseDelay: this.hoverCloseDelay ? this.hoverCloseDelay : 50,
            focusDelay: this.focusDelay ? this.focusDelay : 0,
            blurDelay: this.blurDelay ? this.blurDelay : 50,
            openDelay: this.openDelay ? this.openDelay : 50,
            tetherOptions: this.tetherOptions ? this.tetherOptions : {
                offset: '20px 0'
            },
            remove: this.remove === undefined ? true : this.remove,
        });
    },
    template: `
    <span>
        <div ref="dropTrigger">
            <slot name="drop-trigger"></slot>
        </div>
        <div ref="dropContent" class="">
            <slot name="drop-content"></slot>
        </div>
    </span>
`
}